import React from 'react'
import { LucideIcon } from 'lucide-react'
import { PageActionButton } from 'uiComponents/buttons/pageAddButton'
import { History } from 'history'

interface ProductsViewLinkProps {
    href: string
    label: string
    icon: LucideIcon
    history: History
}

export function ProductsViewLink({ href, label, icon, history }: ProductsViewLinkProps) {
    return (
        <PageActionButton
            icon={icon}
            href={href}
            title={label}
            onClick={(event) => {
                if (event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
                    event.preventDefault()
                    history.push(href)
                }
            }}
        >
            {label}
        </PageActionButton>
    )
}

export default ProductsViewLink
